export const defaultProps = {
    severity: "success",
    vertical: "top",
    horizontal: "right"
};
